import { jsx as a } from "react/jsx-runtime";
import d, { createElement as S } from "react";
import C from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as W } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
const I = C.div`
  ol {
    margin-inline-start: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.marginInlineStart;
}};
    margin-inline-end: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.marginInlineEnd;
}} !important;
    padding-inline-start: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.paddingInlineStart;
}} !important;
    padding-inline-end: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.paddingInlineEnd;
}} !important;

    list-style-position: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.listStylePosition;
}};

    li span.ordered {
      padding-left: ${({ $size: t, theme: n }) => t === "small" ? n == null ? void 0 : n.components.list.ListWrapper.ol.li.paddingLeft.small : t === "large" ? n == null ? void 0 : n.components.list.ListWrapper.ol.li.paddingLeft.large : n == null ? void 0 : n.components.list.ListWrapper.ol.li.paddingLeft.default} !important;
    }

    li ol,
    li ul {
      margin-top: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.li.ol.marginTop;
}};
      margin-inline-start: ${({ $size: t, ...n }) => {
  var i, e, l;
  return t === "small" ? (i = n == null ? void 0 : n.theme) == null ? void 0 : i.components.list.ListWrapper.ol.li.ol.marginInlineStart.small : t === "large" ? (e = n == null ? void 0 : n.theme) == null ? void 0 : e.components.list.ListWrapper.ol.li.ol.marginInlineStart.large : (l = n == null ? void 0 : n.theme) == null ? void 0 : l.components.list.ListWrapper.ol.li.ol.marginInlineStart.default;
}} !important;
    }

    font-family: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.fontFamily;
}};
    font-style: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ol.fontStyle;
}};
  }

  ul {
    margin-inline-start: ${({ $type: t, theme: n }) => t === "none" ? n == null ? void 0 : n.components.list.ListWrapper.ul.marginInlineStart.none : n == null ? void 0 : n.components.list.ListWrapper.ul.marginInlineStart.default} !important;
    margin-inline-end: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.marginInlineEnd;
}} !important;
    padding-inline-start: ${({ $size: t, $type: n, theme: i }) => n === "none" ? i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.none : t === "large" ? i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.large : i == null ? void 0 : i.components.list.ListWrapper.ul.paddingInlineStart.default} !important;
    padding-inline-end: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.paddingInlineEnd;
}} !important;
    font-family: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.fontFamily;
}};
    font-style: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.ul.fontStyle;
}};
  }

  li {
    position: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.li.position;
}};
    margin-bottom: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.li.marginBottom;
}};
  }

  li:last-of-type {
    margin-bottom: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.li.lastOfType;
}};
  }

  li ul {
    margin-inline-start: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.li.ul.marginInlineStart;
}} !important;
    margin-inline-end: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListWrapper.li.ul.marginInlineEnd;
}} !important;
  }
`, U = C.ul`
  list-style: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.UnorderedListContainer.listStyle;
}};
  ${({ size: t, ...n }) => {
  var i, e, l, r, o, s, f, m, L, g, u, $;
  if (t === "small")
    return `
          font-family: ${(i = n == null ? void 0 : n.theme) == null ? void 0 : i.components.list.UnorderedListContainer.textStyle[t].fontFamily}; 
          font-weight: ${(e = n == null ? void 0 : n.theme) == null ? void 0 : e.components.list.UnorderedListContainer.textStyle[t].fontWeight}; 
          font-size: ${(l = n == null ? void 0 : n.theme) == null ? void 0 : l.components.list.UnorderedListContainer.textStyle[t].fontSize}; 
          line-height: ${(r = n == null ? void 0 : n.theme) == null ? void 0 : r.components.list.UnorderedListContainer.textStyle[t].lineHeight};
      `;
  if (t === "medium")
    return `
        font-family: ${(o = n == null ? void 0 : n.theme) == null ? void 0 : o.components.list.UnorderedListContainer.textStyle[t].fontFamily}; 
        font-weight: ${(s = n == null ? void 0 : n.theme) == null ? void 0 : s.components.list.UnorderedListContainer.textStyle[t].fontWeight}; 
        font-size: ${(f = n == null ? void 0 : n.theme) == null ? void 0 : f.components.list.UnorderedListContainer.textStyle[t].fontSize};
        line-height:  ${(m = n == null ? void 0 : n.theme) == null ? void 0 : m.components.list.UnorderedListContainer.textStyle[t].lineHeight};
      `;
  if (t === "large")
    return `
          font-family: ${(L = n == null ? void 0 : n.theme) == null ? void 0 : L.components.list.UnorderedListContainer.textStyle[t].fontFamily}; 
          font-weight: ${(g = n == null ? void 0 : n.theme) == null ? void 0 : g.components.list.UnorderedListContainer.textStyle[t].fontWeight}; 
          font-size: ${(u = n == null ? void 0 : n.theme) == null ? void 0 : u.components.list.UnorderedListContainer.textStyle[t].fontSize};
          line-height: ${($ = n == null ? void 0 : n.theme) == null ? void 0 : $.components.list.UnorderedListContainer.textStyle[t].lineHeight};
      `;
}};
  ${({ type: t, theme: n, size: i }) => {
  switch (t) {
    case "bullet":
      return `
          && > li:before {
            content: ${n == null ? void 0 : n.components.list.UnorderedListContainer.bullet.content};
            position: ${n == null ? void 0 : n.components.list.UnorderedListContainer.bullet.position};
            left: -${i === "large" ? n == null ? void 0 : n.components.list.UnorderedListContainer.bullet.left.large : n == null ? void 0 : n.components.list.UnorderedListContainer.bullet.left.default};
            color: ${n == null ? void 0 : n.components.list.UnorderedListContainer.bullet.color};
          }
        `;
    case "dash":
      return `
          && > li:before {
            content: ${n == null ? void 0 : n.components.list.UnorderedListContainer.dash.content};
            position: ${n == null ? void 0 : n.components.list.UnorderedListContainer.dash.position};
            left: -${i === "large" ? n == null ? void 0 : n.components.list.UnorderedListContainer.dash.left.large : n == null ? void 0 : n.components.list.UnorderedListContainer.dash.left.default};
            color: ${n == null ? void 0 : n.components.list.UnorderedListContainer.dash.color};
          }
        `;
    case "square":
      return `
          && > li:before {
            content: ${n == null ? void 0 : n.components.list.UnorderedListContainer.square.content};
            position: ${n == null ? void 0 : n.components.list.UnorderedListContainer.square.position};
            left: -${i === "large" ? n == null ? void 0 : n.components.list.UnorderedListContainer.square.left.large : n == null ? void 0 : n.components.list.UnorderedListContainer.square.left.default};
            color: ${n == null ? void 0 : n.components.list.UnorderedListContainer.square.color};
          }
        `;
    default:
      return "";
  }
}}
`, x = C.ol`
  ${({ size: t, ...n }) => {
  var i, e, l, r, o, s, f, m, L, g, u, $;
  if (t === "small")
    return `
          font-family: ${(i = n.theme) == null ? void 0 : i.components.list.OrderedListContainer.textStyle[t].fontFamily}; 
          font-weight: ${(e = n.theme) == null ? void 0 : e.components.list.OrderedListContainer.textStyle[t].fontWeight}; 
          font-size: ${(l = n.theme) == null ? void 0 : l.components.list.OrderedListContainer.textStyle[t].fontSize}; 
          line-height: ${(r = n.theme) == null ? void 0 : r.components.list.OrderedListContainer.textStyle[t].lineHeight};
      `;
  if (t === "medium")
    return `
        font-family: ${(o = n.theme) == null ? void 0 : o.components.list.OrderedListContainer.textStyle[t].fontFamily}; 
        font-weight: ${(s = n.theme) == null ? void 0 : s.components.list.OrderedListContainer.textStyle[t].fontWeight}; 
        font-size: ${(f = n.theme) == null ? void 0 : f.components.list.OrderedListContainer.textStyle[t].fontSize};
        line-height:  ${(m = n.theme) == null ? void 0 : m.components.list.OrderedListContainer.textStyle[t].lineHeight};
      `;
  if (t === "large")
    return `
          font-family: ${(L = n.theme) == null ? void 0 : L.components.list.OrderedListContainer.textStyle[t].fontFamily}; 
          font-weight: ${(g = n.theme) == null ? void 0 : g.components.list.OrderedListContainer.textStyle[t].fontWeight}; 
          font-size: ${(u = n.theme) == null ? void 0 : u.components.list.OrderedListContainer.textStyle[t].fontSize};
          line-height: ${($ = n.theme) == null ? void 0 : $.components.list.OrderedListContainer.textStyle[t].lineHeight};
      `;
}};
  list-style-type: ${({ type: t }) => t};
  color: ${(t) => {
  var n;
  return (n = t.theme) == null ? void 0 : n.components.list.OrderedListContainer.color;
}};
  ${({ type: t, $size: n, theme: i }) => {
  if (t === "lower-roman" || t === "upper-roman")
    return `li span.ordered {
      padding-left: ${i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.paddingLeft};
      position: ${i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.position};
      left: ${n === "small" ? i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.small : n === "large" ? i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.large : i == null ? void 0 : i.components.list.OrderedListContainer.lowerRoman.left.default} !important;`;
}}
  &
    ::marker {
    color: ${({ theme: t }) => t == null ? void 0 : t.components.list.OrderedListContainer.marker.color};
    font-weight: ${({ $lowImpact: t, theme: n }) => t ? n == null ? void 0 : n.components.list.OrderedListContainer.marker.fontWeight.lowImpact : n == null ? void 0 : n.components.list.OrderedListContainer.marker.fontWeight.default};
  }
`, O = C.li`
  color: ${({ theme: t, $isLink: n }) => n ? t == null ? void 0 : t.components.list.ListItemContainer.color.link : t == null ? void 0 : t.components.list.ListItemContainer.color.default};
  cursor: ${({ $isLink: t, theme: n }) => t ? n == null ? void 0 : n.components.list.ListItemContainer.cursor.link : n == null ? void 0 : n.components.list.ListItemContainer.cursor.default};
  font-size: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListItemContainer.fontSize;
}};
  line-height: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListItemContainer.lineHeight;
}};
  font-weight: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListItemContainer.fontWeight;
}};
`, w = C.span`
  display: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListIconContainer.display;
}};
  vertical-align: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListIconContainer.verticalAlign;
}};
  margin-right: ${(t) => {
  var n;
  return (n = t == null ? void 0 : t.theme) == null ? void 0 : n.components.list.ListIconContainer.marginRight;
}};
`, b = ({ component: t, color: n }) => /* @__PURE__ */ a(w, { role: "img", children: /* @__PURE__ */ a(
  t,
  {
    width: "20px",
    height: "20px",
    color: n
  }
) }), c = ({ children: t, type: n, onClick: i }) => /* @__PURE__ */ a(
  O,
  {
    role: "listitem",
    size: n === "decimal" ? "medium" : "small",
    onClick: (e) => {
      i && i(e);
    },
    $isLink: !!i,
    children: ["decimal", "lower-alpha", "upper-alpha", "lower-roman", "upper-roman"].includes(n) ? /* @__PURE__ */ a("span", { className: "ordered", children: t }) : t
  }
), E = ({ size: t = "medium", type: n, children: i, lowImpact: e = !1 }) => {
  const l = W({ label: "List" }), r = ["decimal", "lower-alpha", "upper-alpha", "lower-roman", "upper-roman"].includes(n) ? y : k;
  return /* @__PURE__ */ a(
    I,
    {
      $size: t,
      $type: n,
      ...l,
      children: /* @__PURE__ */ a(
        r,
        {
          role: "list",
          size: t,
          type: n,
          lowImpact: e,
          children: d.Children.map(i, (o, s) => o && typeof o == "string" ? /* @__PURE__ */ a(
            c,
            {
              size: t,
              type: n,
              children: o
            },
            s
          ) : o && d.isValidElement(o) && o.type === c ? d.cloneElement(o, {
            key: s,
            size: t,
            onClick: o.props.onClick
          }) : null)
        }
      )
    }
  );
}, k = ({
  type: t,
  size: n = "medium",
  children: i
}) => /* @__PURE__ */ a(
  U,
  {
    role: "list",
    type: t,
    size: n,
    children: d.Children.map(i, (e, l) => e && d.isValidElement(e) && e.type === c ? /* @__PURE__ */ S(
      c,
      {
        ...e.props,
        size: n,
        key: l,
        type: t
      },
      e.props.children
    ) : null)
  }
), y = ({
  size: t = "medium",
  children: n,
  type: i = "decimal",
  lowImpact: e
}) => /* @__PURE__ */ a(
  x,
  {
    role: "list",
    size: t,
    type: i,
    $lowImpact: e,
    children: d.Children.map(n, (l, r) => d.isValidElement(l) && l.type === c ? /* @__PURE__ */ a(
      c,
      {
        type: i,
        ...l.props,
        children: d.Children.toArray(l.props.children)
      },
      r
    ) : d.isValidElement(l) && l.type === y ? /* @__PURE__ */ a(
      y,
      {
        size: t,
        type: l.props.type,
        children: l.props.children
      },
      r
    ) : /* @__PURE__ */ a("li", { children: l }, r))
  }
);
E.Item = c;
c.Icon = b;
export {
  E as List,
  b as ListIcon,
  c as ListItem
};
